import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { APP_CONSTANTS } from '../../../config/utils/AppContext';
import { sendLoadComplete, sendNativeBackControl } from '../../../config/utils/external-interface';
import { getOS } from "../../../config/utils/utils";
import { getUIConfig, getWheel } from "../../../config/services/spinService";

let userIdPara = ''
const Loader = () => {
    const navigate = useNavigate();
    const [loginResponse,setLoginResponse] = useState();
    //const [utmParams, setUtmParams] = useState({});

    useEffect(() => {
        userIdPara = getParameterByName("userId")
        const utmData = getAllUTMParameters();
        tokenValidity(utmData);
        sendLoadComplete();
        sendNativeBackControl(false);
    }, [])

    const getAllUTMParameters = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const utmParams = {};
        
        // Get all UTM parameters
        for (const [key, value] of urlParams.entries()) {
            if (key.toLowerCase().startsWith('utm_')) {
                utmParams[key] = value;
            }
        }
        
        return utmParams;
    };

    const getAllParameters = () => {
        let params = {};

        console.log("params",);


        window.location.search
            .slice(1)
            .split("&")
            .forEach((query) => {
                const queryKey = query.split("=")[0];
                if (queryKey && queryKey !== "jwt") {
                    params[queryKey] = getParameterByName(queryKey);
                } else if (queryKey === "jwt") {
                    APP_CONSTANTS.token.jwt = getParameterByName(queryKey);
                }
            });

        return params;
    };


    const getParameterByName = (name, url) => {
        if (!url) {
            url = window.location.href;
        }
        name = name.replace(/[\[\]]/g, "\\$&");
        const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
        const results = regex.exec(url);
        if (!results) {
            return null;
        }
        if (!results[2]) {
            return "";
        }
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    };
    useEffect(() => {
        if(loginResponse){
            getWheelData();
        }
    },[loginResponse])


    const tokenValidity = (utmData) => {
        let loginParams = {
            device: "smartphone", ...getAllParameters(),
            userId: getParameterByName('userId') || null,
            guestUserId:getParameterByName('anonymousId') || null,
            platform: getOS() == 'browser' ? 'browser' : 'tira',
            user_agent: getOS(),
            utm_params: utmData,
            gametype:"spin2win"
        };

        if (!getParameterByName('userId') && !getParameterByName('anonymousId')) {
            navigate('/fallback')
            return;
        }

        return axios
            .post(`${process.env.REACT_APP_API_HOST}/login`, loginParams)
            .then((res) => {
                APP_CONSTANTS.token.jwt = res.data.jwt;
                if(res?.data?.prize){
                    setLoginResponse(res?.data);
                    if(loginResponse){
                        getWheelData();

                    }
                }else{
                    navigate('/home',{ state: { utmParams: utmData }})

                }
            }).catch((err) => {
                navigate('/fallback')
            })
    };
    const getWheelData = async () => {
        try {
          const response = await getWheel();
          const uiC = await getUIConfig(response?.uiConfigId); // needs testing
          console.log(loginResponse)
          navigate('/result',{ state: { prizes: loginResponse,uiConfig: uiC  } })
    
        } catch (error) {
          console.error("Error fetching data:", error);
          navigate("/fallback", { state: { error: error.message } });
        }
      };


}


export const userId = () => {
    return userIdPara;
}



export default Loader;

